import Input from "./Input";
import SearchInput from "./SearchInput";
import InputMUI from "./InputMui";

export { Input, SearchInput, InputMUI };

export default Input;
